import React from "react";
import { ThreeDots } from "react-loader-spinner";

const ActionButton = ({
  text,
  newBtn,
  getAllBtn,
  isPrint,
  isGo,
  icon: Icon,
  onClick,
  disabled = false,
  isLoading = false,
  no_ml = false,
  variant = "save",
  type = "button",
  id,
  className = "",
  style = {},
}) => {
  const getButtonClass = () => {
    switch (variant) {
      case "cancel":
        return "cancel_btn";
      case "save":
        return "save_btn";
      case "info":
        return "info_btn";
      case "grey":
        return "grey_btn";
      default:
        return variant;
    }
  };

  return (
    <button
      type={type}
      className={`${getButtonClass()} ${no_ml ? "" : "ml-2"} ${className}`}
      onClick={onClick}
      disabled={disabled || isLoading}
      id={id}
      style={{
        minWidth: getAllBtn ? 60 : newBtn ? 40 : 70,
        height: newBtn ? 25 : 30,
        position: "relative",
        borderRadius: isGo ? "16px" : "",
        ...style,
      }}
    >
      {isLoading ? (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <ThreeDots color="green" height={10} width={35} />
        </div>
      ) : (
        <>
          {Icon && <Icon size="1em" className="mr-1 mb-1" />}
          <span
            style={{
              fontSize: isPrint ? 14 : 14,
            }}
          >
            {text}
          </span>
        </>
      )}
    </button>
  );
};

export default ActionButton;
